export const theme = {
  colors: {
    background: '#0B0E11',
    surface: '#111418',
    surfaceElevated: '#15191E',
    surfaceMuted: '#1A1F24',
    surfaceTransparent: 'rgba(26, 31, 36, 0.82)',
    border: '#272C33',
    borderMuted: '#323840',
    accent: '#2C81DD',
    accentStrong: '#2267B4',
    accentSoft: '#12365D',
    textPrimary: '#E5E7EB',
    textSecondary: '#A4ACB5',
    textMuted: '#6E7681',
    textInverse: '#0B0E11',
    success: '#1C8F4B',
    warning: '#B97A13',
    danger: '#B83E3E',
    positiveGradient: 'rgba(28, 143, 75, 0.18)',
    neutralGradient: 'rgba(44, 129, 221, 0.14)',
    negativeGradient: 'rgba(184, 62, 62, 0.16)'
  },
  radii: {
    sm: 12,
    md: 18,
    lg: 28,
    xl: 40,
    pill: 999
  },
  spacing: {
    xs: 8,
    sm: 12,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48
  },
  typography: {
    family: "'Inter', 'SF Pro Display', 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif",
    weights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    },
    sizes: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xxl: '1.5rem'
    }
  },
  shadows: {
    soft: '0 24px 60px rgba(8, 12, 24, 0.35)',
    ring: 'inset 0 1px 0 rgba(255, 255, 255, 0.05)',
    border: '0 0 0 1px rgba(148, 163, 184, 0.18)'
  }
};

export const sidebarNav = [
  { label: 'Overview', path: '/dashboard', icon: 'FiLayout' },
  { label: 'Shipments', path: '/shipments', icon: 'FiTruck' },
  { label: 'Bookings', path: '/bookings', icon: 'FiBookmark' },
  { label: 'Carriers', path: '/carriers', icon: 'FiBox' },
  { label: 'Accounts Payable', path: '/accounts', icon: 'FiCreditCard' },
  { label: 'Analytics', path: '/stats', icon: 'FiBarChart2' },
  { label: 'Settings', path: '/settings', icon: 'FiSettings' }
];
